/**
 * @flow
 * @relayHash 548c9dbea0050536a38a48085f27c0b9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BackgroundSettingsContainer_app$ref = any;
type BackgroundSettingsContainer_user$ref = any;
export type BackgroundSettingsViewQueryVariables = {|
  userId: string
|};
export type BackgroundSettingsViewQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: BackgroundSettingsContainer_app$ref
  |},
  +user: ?{|
    +$fragmentRefs: BackgroundSettingsContainer_user$ref
  |},
|};
export type BackgroundSettingsViewQuery = {|
  variables: BackgroundSettingsViewQueryVariables,
  response: BackgroundSettingsViewQueryResponse,
|};
*/


/*
query BackgroundSettingsViewQuery(
  $userId: String!
) {
  app {
    ...BackgroundSettingsContainer_app
    id
  }
  user(userId: $userId) {
    ...BackgroundSettingsContainer_user
    id
  }
}

fragment BackgroundSettingsContainer_app on App {
  ...BackgroundImagePickerContainer_app
}

fragment BackgroundSettingsContainer_user on User {
  id
  backgroundOption
  customImage
  backgroundColor
  backgroundImage {
    imageURL
    id
  }
  ...BackgroundImagePickerContainer_user
  ...BackgroundColorPickerContainer_user
  ...BackgroundCustomImagePickerContainer_user
}

fragment BackgroundImagePickerContainer_user on User {
  backgroundImage {
    id
    imageURL
  }
}

fragment BackgroundColorPickerContainer_user on User {
  backgroundColor
}

fragment BackgroundCustomImagePickerContainer_user on User {
  customImage
}

fragment BackgroundImagePickerContainer_app on App {
  backgroundImages(first: 50) {
    edges {
      node {
        id
        name
        imageURL
        thumbnailURL
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageURL",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "BackgroundSettingsViewQuery",
  "id": null,
  "text": "query BackgroundSettingsViewQuery(\n  $userId: String!\n) {\n  app {\n    ...BackgroundSettingsContainer_app\n    id\n  }\n  user(userId: $userId) {\n    ...BackgroundSettingsContainer_user\n    id\n  }\n}\n\nfragment BackgroundSettingsContainer_app on App {\n  ...BackgroundImagePickerContainer_app\n}\n\nfragment BackgroundSettingsContainer_user on User {\n  id\n  backgroundOption\n  customImage\n  backgroundColor\n  backgroundImage {\n    imageURL\n    id\n  }\n  ...BackgroundImagePickerContainer_user\n  ...BackgroundColorPickerContainer_user\n  ...BackgroundCustomImagePickerContainer_user\n}\n\nfragment BackgroundImagePickerContainer_user on User {\n  backgroundImage {\n    id\n    imageURL\n  }\n}\n\nfragment BackgroundColorPickerContainer_user on User {\n  backgroundColor\n}\n\nfragment BackgroundCustomImagePickerContainer_user on User {\n  customImage\n}\n\nfragment BackgroundImagePickerContainer_app on App {\n  backgroundImages(first: 50) {\n    edges {\n      node {\n        id\n        name\n        imageURL\n        thumbnailURL\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "BackgroundSettingsViewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "BackgroundSettingsContainer_app",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "BackgroundSettingsContainer_user",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "BackgroundSettingsViewQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "backgroundImages",
            "storageKey": "backgroundImages(first:50)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 50,
                "type": "Int"
              }
            ],
            "concreteType": "BackgroundImageConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BackgroundImageEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BackgroundImage",
                    "plural": false,
                    "selections": [
                      v2,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      v3,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "thumbnailURL",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v2
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "backgroundOption",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "customImage",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "backgroundColor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "backgroundImage",
            "storageKey": null,
            "args": null,
            "concreteType": "BackgroundImage",
            "plural": false,
            "selections": [
              v3,
              v2
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a493cf5b4093e9ce1e498dc271107391';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Background/__generated__/BackgroundSettingsViewQuery.graphql.js